var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTickCircled = function SvgTickCircled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tick_circled_svg2__a",
    x1: -0.34,
    x2: 199.66,
    y1: 100.04,
    y2: 100.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M199.66 100.04c0 19.74-5.86 38.93-16.94 55.51a7.814 7.814 0 1 1-12.99-8.69c9.36-14 14.31-30.19 14.31-46.83 0-7.15-.89-14.25-2.66-21.1a7.8 7.8 0 0 1 5.62-9.51c4.18-1.07 8.44 1.44 9.51 5.62 2.09 8.12 3.15 16.53 3.15 25m-56.35 72.23c-13.12 7.95-28.22 12.15-43.65 12.15-46.52 0-84.37-37.85-84.37-84.37s37.85-84.38 84.37-84.38c17.23 0 33.79 5.15 47.9 14.91 3.55 2.45 8.42 1.56 10.87-1.99s1.56-8.42-1.99-10.87C139.71 6.16 120.07.04 99.66.04c-26.71 0-51.82 10.4-70.71 29.29s-29.29 44-29.29 70.71 10.4 51.82 29.29 70.71 44 29.29 70.71 29.29c18.29 0 36.18-4.98 51.74-14.41a7.82 7.82 0 0 0 2.64-10.73c-2.24-3.69-7.04-4.87-10.73-2.63m-42.9-49.57c-1.24.05-2.39-.39-3.29-1.25L56.2 82.65c-3.13-2.97-8.08-2.84-11.04.29-2.97 3.13-2.84 8.08.29 11.04l40.91 38.79c3.78 3.59 8.67 5.54 13.84 5.54.28 0 .56 0 .83-.02 5.49-.22 10.52-2.6 14.19-6.69.09-.1.18-.21.27-.32l82.44-102.51c2.7-3.36 2.17-8.28-1.19-10.98s-8.28-2.17-10.98 1.19l-82.28 102.34c-.81.84-1.89 1.33-3.07 1.38",
    style: {
      fill: "url(#tick_circled_svg2__a)",
      strokeWidth: 0
    }
  }));
};
export default SvgTickCircled;